import { CmsHelpTrainingDetail } from '../../../../components/Cms';

export function CmsHelpTrainingDetails() {
  return <CmsHelpTrainingDetail />;
}
